import React from 'react';
interface SectionProps {
  id?: string;
  tone?: 'cream' | 'white' | 'navy' | 'soft';
  className?: string;
  children: React.ReactNode;
}
const tones = {
  cream: 'bg-cream text-navy',
  white: 'bg-white text-navy',
  soft: 'bg-brand-soft text-navy',
  navy: 'bg-navy text-white'
};
export function Section({
  id,
  tone = 'cream',
  className = '',
  children
}: SectionProps) {
  return <section id={id} className={`w-full px-4 py-12 sm:px-6 sm:py-20 ${tones[tone]} ${className}`} data-id="element-67" data-mp="cfwzvmkesfvb">
      <div className="mx-auto w-full max-w-content" data-id="element-68" data-mp="hehyjhk0irhn">{children}</div>
    </section>;
}
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function Eyebrow({
  children,
  tone = 'light'
}: EyebrowProps) {
  return <p className={`mb-3 text-center text-[11px] font-extrabold uppercase tracking-[0.2em] ${tone === 'dark' ? 'text-brand-light' : 'text-brand'}`} data-id="element-69" data-mp="7ndlindwdgpg">
      {children}
    </p>;
}
interface HeadingProps {
  children: React.ReactNode;
  as?: 'h2' | 'h3';
  className?: string;
}
export function Heading({
  children,
  as = 'h2',
  className = ''
}: HeadingProps) {
  const Tag = as;
  return <Tag className={`text-balance text-center font-serif text-[27px] font-extrabold leading-[1.13] tracking-tight sm:text-4xl md:text-[42px] ${className}`} data-id="element-70" data-mp="2uje6gia7dnao">
      {children}
    </Tag>;
}